import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mdiPlayOutline } from "@mdi/js";

@Component({})
export default class VideoPanel extends Vue {
  playIcon = mdiPlayOutline;
  dialog = false;
}